export default "__VITE_ASSET__B2$x1w$d__"